import { useContext } from 'react';
import { scrollAddContext } from './context';

export const useScrollAdd = () => {
  const scrollTo = useContext(scrollAddContext);
  return scrollTo;
};
